import React from 'react';
import LogOutSubmit from '../../../components/auth/SubmitLogOut';

const ErrorView = () => {
  return <LogOutSubmit />;
};

export default ErrorView;
